import type { Menu, MenuItem } from '@frontend/libs/types/site-configuration'
import type React from 'react'

import Drawer from '@frontend/components/drawer/Drawer'
import { ChevronLeftIcon } from '@heroicons/react/24/outline'
import { Button } from '@nextui-org/react'
import { __ } from '@wordpress/i18n'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import NavMenuItem from './NavMenuItem'

export type NestedSubMenuDrawerProps = {
  children: React.ReactNode
  menu: Menu | MenuItem
}

export const NestedMenuDrawer: React.FC<NestedSubMenuDrawerProps> = ({
  children,
  menu,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const location = useLocation()

  useEffect(() => {
    return () => {
      setIsOpen(false)
    }
  }, [location])

  return (
    <>
      <NavMenuItem
        hasSubMenu
        onPress={() => setIsOpen(true)}
        title={menu.title}
      />
      <Drawer
        hideCloseButton
        isFullWidth
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        position="right"
      >
        <Drawer.Content>
          <div className="mt-6">
            <h3 className="text-center text-lg font-medium uppercase">
              {menu.title}
            </h3>
            <Button
              className="mb-4 flex justify-between px-0 uppercase"
              fullWidth
              onPress={() => setIsOpen(false)}
              size="lg"
              variant="light"
            >
              {__('Back', 'asavagroup')}
              <ChevronLeftIcon className="h-6 w-6" />
            </Button>
            <div className="h-[calc(100dvh_-_10rem)] overflow-y-auto md:h-[calc(100dvh_-_10rem)]">
              {children}
            </div>
          </div>
        </Drawer.Content>
      </Drawer>
    </>
  )
}

export default NestedMenuDrawer
